<template>
  <v-row class="mx-0 align-center">
    <v-col
      cols="4"
      class="pa-0"
    >
      <span class="font-weight-medium">Income Tax Number</span>
    </v-col>
    <v-col
      cols="1"
      class="pa-0"
    >
      <span class="font-weight-medium">:</span>
    </v-col>
    <v-col
      cols="7"
      class="pa-0 d-flex align-center"
    >
      <v-progress-circular
        v-if="loading"
        indeterminate
        size="20"
        width="3"
        color="primary"
        class="ml-3"
      />
      <span
        v-else
        class="pl-3"
      >
        {{ (incomeTaxDetail||{}).income_tax_number ||'N/A' }}
      </span>
      <employee-profile-payroll-income-tax-detail-dialog-edit
        v-if="$hasPermissionTo(['update employee payroll']) && !isResigned && !loading"
        :income-tax-detail="incomeTaxDetail"
        :employee-uid="employeeUid"
        @updated="loadEmployeeIncomeTax"
      />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollIncomeTaxDetailDialogEdit: () => import('@/components/hris/employee/profile/payroll/income-tax-detail/DialogEdit'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        incomeTaxDetail: {},
      }
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (newVal, oldVal) {
          if (!_.isEmpty(newVal)) {
            this.loadEmployeeIncomeTax()
          }
        },
      },
    },
  
    methods: {
      loadEmployeeIncomeTax () {
        this.loading = true

        this.$api.employeePayrollIncomeTax().list(this.employeeUid)
          .then(res => {
            this.incomeTaxDetail = res.data

            this.loading = false
          })
      },
    },
  }
</script>
